import Dispatcher from '../dispatcher';
import { FSHomePageLightBoxActions } from '../constants/fs_home_page_light_box/fs_home_page_light_box_actions';

function showAction() {
    Dispatcher.handleFSHomePageLightboxAction({
        type: FSHomePageLightBoxActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleFSHomePageLightboxAction({
        type: FSHomePageLightBoxActions.HIDE
    });
}

export {
    showAction,
    hideAction
};
